import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import RegistrationModalApp from './RegistrationModalApp.vue';
import axios from 'axios';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default (passProps) => {
  const props = JSON.parse(passProps.getAttribute('data'));

  if (document.querySelector('meta[name="csrf-token"]')) {
    axios.defaults.headers.common['X-CSRF-Token'] = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute('content');
  }
  axios.defaults.headers.common.Accept = 'application/json';

  new Vue({
    render: (h) => h(RegistrationModalApp, { props }),
  }).$mount('#registration_modal');
};


